import React from 'react'
import { withStyles } from 'material-ui/styles'

const MAX_WIDTH = 400

const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  inner: {
    width: '100%',
    maxWidth: MAX_WIDTH,
    marginTop: 2 * theme.spacing.unit
  }
})

export const MaxWidthContainer = withStyles(styles)(({ classes, ...props }) => (
  <div className={classes.container}>
    <div className={classes.inner} {...props} />
  </div>
))



// WEBPACK FOOTER //
// ./src/helpers/layout.js